/**
 * Shared allowlist helpers for iframe parent origins.
 * Source of truth for the list itself is environment.allowedParentOrigins
 * in envStore.svelte.js (build-time per customer).
 */

export function isUnrestrictedParentOrigins(origins) {
    if (!Array.isArray(origins) || origins.length === 0) {
        return true;
    }
    return origins.includes("*");
}

export function penpalAllowedOrigins(origins) {
    if (isUnrestrictedParentOrigins(origins)) {
        return ["*"];
    }
    return origins;
}

export function frameAncestorsValue(origins) {
    if (isUnrestrictedParentOrigins(origins)) {
        return null;
    }
    return origins.join(" ");
}

export function applyFrameAncestorsToCsp(csp, origins) {
    const without = String(csp ?? "")
        .replace(/;?\s*frame-ancestors\s+[^;]*/gi, "")
        .replace(/;\s*$/g, "")
        .trim();
    const directive = frameAncestorsValue(origins);
    if (!directive) {
        return without;
    }
    return `${without}; frame-ancestors ${directive}`;
}

export function parseAllowedParentOriginsFromEnvStore(source) {
    const match = String(source ?? "").match(
        /allowedParentOrigins\s*:\s*(\[[\s\S]*?\])/,
    );
    if (!match) {
        throw new Error(
            "Could not find allowedParentOrigins in envStore.svelte.js",
        );
    }

    try {
        const parsed = JSON.parse(match[1]);
        if (!Array.isArray(parsed)) {
            throw new Error("allowedParentOrigins is not an array");
        }
        return parsed;
    } catch {
        const quoted = [...match[1].matchAll(/["']([^"']+)["']/g)].map(
            (entry) => entry[1],
        );
        return quoted;
    }
}
